import { mobileBreakpoint } from 'shared/javascripts/util/mobile_breakpoint'

const sharedOverlayOptions = {
  layer: 'new',
  mode: 'cover',
  closeAnimation: 'move-to-bottom',
  class: 'mobile-drawer',
} as const

up.compiler('[data-open-in-drawer-on-mobile-link]', (element: HTMLAnchorElement) => {
  element.addEventListener('up:click', (event: Event) => {
    event.preventDefault()

    let options: Record<string, any> = {}

    if (mobileBreakpoint.matches) {
      options = {
        ...sharedOverlayOptions,
        openAnimation: 'move-from-bottom',
      }
    }

    options = {
      ...options,
      metaTags: false, // avoid updating the canonical tag because of SEO
      title: false,
    }
    up.follow(element, options)
  })
})

up.compiler('[data-auto-in-drawer-on-mobile]', (element: HTMLElement) => {
  if (mobileBreakpoint.matches && up.layer.isRoot()) {
    void up.layer.open({
      ...sharedOverlayOptions,
      fragment: element.outerHTML,
      target: '[data-in-drawer-on-mobile]',
    })
  }
})
